import { TfiClose } from 'react-icons/tfi';
export default TfiClose;

//# sourceMappingURL=Close.js.map